"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Calendar = function (_a) {
    var _b = _a.color, color = _b === void 0 ? '#000' : _b, _c = _a.scale, scale = _c === void 0 ? 1 : _c;
    return (react_1.default.createElement("svg", { width: 24 * scale, height: 24 * scale, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("path", { d: "M19 4H5C3.89543 4 3 4.89543 3 6V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V6C21 4.89543 20.1046 4 19 4Z", stroke: "#1F1F1F", strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M16 2V6", stroke: color, strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M8 2V6", stroke: color, strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M3 10H21", stroke: color, strokeLinecap: "round", strokeLinejoin: "round" })));
};
exports.default = Calendar;
//# sourceMappingURL=Calendar.js.map